<template>
  <div v-show="rooms.length">
    <translate v-if="!hideTitle" tag="h4" :tt="{ rooms: rooms.length }">
      {rooms} rooms
    </translate>
    <p v-for="(room, index) in rooms" :key="index">
      {{ room.roomType.name }}
      <span class="bed-types"
        ><template v-for="(content, count, spanIndex) of roomContent(room)"
          >{{ content }} x {{ count
          }}<template
            v-if="spanIndex != Object.keys(roomContent(room)).length - 1"
            >,
          </template>
        </template>
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'Bedrooms',
  props: {
    rooms: {
      type: Array,
      default: undefined,
    },
    hideTitle: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    roomContent(room) {
      const roomContent = {}
      for (const content of room.content) {
        if (roomContent[content.name]) {
          roomContent[content.name]++
        } else {
          roomContent[content.name] = 1
        }
      }
      return roomContent
    },
  },
}
</script>

<style scoped>
p {
  margin: 0 0 0.4em 0;
}

.bed-types:after {
  content: ')';
}

.bed-types:before {
  content: '(';
}
</style>
